module.exports = __webpack_public_path__ + "media/images/apple-icon-a7c53a712f1a7d6bf0c8d91c54ee8f05.png";